export default __webpack_public_path__ + "static/media/side-bar-bg.846f248e.webp";